module.exports = __webpack_public_path__ + "static/media/registration_auth.5ec0a8aa.png";